import { createReducer, on } from '@ngrx/store';
import {StateStatus} from "../../../shared/models/state-status.models";
import {
  reRunBulkUpload, reRunBulkUploadFailure, reRunBulkUploadSuccess,
  runBulkUpload,
  runBulkUploadFailure,
  runBulkUploadLibrary, runBulkUploadLibraryFailure,
  runBulkUploadLibrarySuccess,
  runBulkUploadSuccess
} from "./bulk-upload.action";

export interface BulkUploadState {
  error: string | null;
  bulkUploadStatus: StateStatus;
  reBulkUploadStatus: StateStatus;
  bulkUploadLibraryStatus: StateStatus;
  runBulkUploadError: string | null;

}

export const initialState: BulkUploadState = {
  error: null,
  bulkUploadStatus: 'pending' as StateStatus,
  reBulkUploadStatus: 'pending' as StateStatus,
  bulkUploadLibraryStatus: 'pending' as StateStatus,
  runBulkUploadError: null
};

export const bulkUploadReducer = createReducer(
  initialState,
  on(runBulkUpload, (state): BulkUploadState => ({
    ...state,
    bulkUploadStatus: 'adding' as StateStatus,
    runBulkUploadError: null
  })),
  on(runBulkUploadSuccess, (state, { tenant }): BulkUploadState => ({
    ...state,
    error: null,
    bulkUploadStatus: 'addSuccess' as StateStatus,
  })),
  on(runBulkUploadFailure, (state, { error }) : BulkUploadState => ({
    ...state,
    runBulkUploadError: error,
    bulkUploadStatus: 'error' as StateStatus,
  })),
  on(runBulkUploadLibrary, (state): BulkUploadState => ({
    ...state,
    bulkUploadLibraryStatus: 'loading' as StateStatus,
  })),
  on(runBulkUploadLibrarySuccess, (state): BulkUploadState => ({
    ...state,
    error: null,
    bulkUploadLibraryStatus: 'loadSuccess' as StateStatus,
  })),
  on(runBulkUploadLibraryFailure, (state, { error }) : BulkUploadState => ({
    ...state,
    error: error,
    bulkUploadLibraryStatus: 'loadError' as StateStatus,
  })),

  on(reRunBulkUpload, (state): BulkUploadState => ({
    ...state,
    bulkUploadStatus: 'loading' as StateStatus,
  })),
  on(reRunBulkUploadSuccess, (state, { tenant }): BulkUploadState => ({
    ...state,
    error: null,
    reBulkUploadStatus: 'loadSuccess' as StateStatus,
  })),
  on(reRunBulkUploadFailure, (state, { error }) : BulkUploadState => ({
    ...state,
    error: error,
    reBulkUploadStatus: 'loadError' as StateStatus,
  })),
);
